"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessage = sendMessage;
var _context = require("./context");
var _coreMessaging = _interopRequireDefault(require("../core-messaging"));
var _coreSanitize = _interopRequireDefault(require("../core-sanitize"));
var _coreUtil = require("../core-util");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Send a message to a specific SDK
 *
 * @module core-bootstrap-send-message
 */

/**
 * Sends a message to the specified SDK.
 *
 * @param {string} action The action to send
 * @param {*} data The data to send
 * @param {string} iframeId The UUID of the target iframe for this command
 * @return {boolean} true if command was dispatched to the SDK, false otherwise
 */
function sendMessage(action, data, iframeId) {
  var iframeEntry = (0, _context.getIframeConfiguration)(iframeId);
  if (!iframeEntry) {
    return false;
  }
  var destination = undefined;
  if (iframeEntry.element) {
    destination = iframeEntry.element.contentWindow;
  }
  _coreMessaging["default"].sendMessage({
    action: action,
    data: (0, _coreUtil.stringFormatter)(_coreSanitize["default"].sanitizeAll)(data),
    destination: destination,
    overrideNonce: iframeEntry.nonce,
    overrideID: iframeEntry.id
  });
  return true;
}
//# sourceMappingURL=send-message.js.map